import React, { useEffect, useState } from "react";
import { MdIntegrationsModel } from "../../models";
import { DataTable } from "../../components";
import { MdIntegrationsInterface } from "../../interfaces";

const ViewMdIntegrations = () => {
  const [mdEvents, setMdEvents] = useState<MdIntegrationsInterface[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [isLoading, setIsLoading] = useState(false);
  

  const fetchMdEvents = async (pageIndex: number, pageSize: number) => {
    try {
      setIsLoading(true);
      const skip = pageIndex * pageSize;

      const resp = await MdIntegrationsModel.fetchAll<any>({
        $skip: skip,
        $limit: pageSize,
        $sort: { createdAt: -1 },
      });

      return {
        rows: resp.data,
        totalCount: resp.total,
      };
    } catch (error: any) {
      throw new Error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMdEvents(pagination.pageIndex, pagination.pageSize).then((res) => {
      setMdEvents(res.rows);
      setTotalCount(res.totalCount);
    });
  }, [pagination]);

  return <DataTable 
    columns={MdIntegrationsModel.getColumns()} 
    data={mdEvents}  
    pagination={pagination}
    onPaginationChange={setPagination}
    totalRowCount={totalCount}
    loading={isLoading}
  />;
};

export default ViewMdIntegrations;
